import React from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';

const withTranslation = (Component) => (props) => {
  const translateString = useTranslation();
  return <Component translateString={translateString} {...props} />;
};

export default withTranslation;
